import Phaser from "phaser";
import { CoinSprite } from "../sprites/CoinSprite";

export class CoinBehaviour {
  private readonly coin: CoinSprite;
  private readonly scene: Phaser.Scene;

  constructor(
    scene: Phaser.Scene,
    start: Phaser.Math.Vector2,
    end: Phaser.Math.Vector2,
    delay = 0,
  ) {
    this.scene = scene;
    this.coin = new CoinSprite(scene, start.x, start.y);
    this.coin.setDepth(1000);

    const curve = new Phaser.Curves.QuadraticBezier(
      start,
      new Phaser.Math.Vector2(
        (start.x + end.x) / 2,
        Math.min(start.y, end.y) - 80,
      ),
      end,
    );

    const DURATION = 600;
    scene.tweens.addCounter({
      from: 0,
      to: 1,
      duration: DURATION,
      delay,
      ease: "Sine.easeInOut",
      onUpdate: (t) => {
        const p = curve.getPoint(t.getValue());
        this.coin.setPosition(p.x, p.y);
      },
      onComplete: () => this.coin.destroy(),
    });

    // Scale punch for a bit of juice
    scene.tweens.add({
      targets: this.coin,
      scale: { from: 0.3, to: 0.6 },
      yoyo: true,
      ease: "Quad.easeOut",
      duration: DURATION * 0.5,
      delay,
    });
  }
}
